<template>
  <div>
    <components-renderer
      v-if="components.length > 0"
      :components="components"
    ></components-renderer>
    <!-- <div
      v-else
      v-html="content"
    ></div> -->
  </div>
</template>


<script>
import { mapState } from 'vuex'

import ComponentsRenderer from '@/component/common/components-renderer.js'

export default {
  props: {
    seq: { type: [Number, String], required: true }
  },
  computed: {
    ...mapState(['designPost']),
    components () {
      if (this.designPost.seq.hasOwnProperty(this.seq) && this.designPost.seq[this.seq].hasOwnProperty('components')) {
        return this.designPost.seq[this.seq].components
      } else if (this.designPost.key.hasOwnProperty(this.seq) && this.designPost.key[this.seq].hasOwnProperty('components')) {
        return this.designPost.key[this.seq].components
      } else {
        console.log('warning!!----------------', this.seq, this.designPost)
        return []
      }
    }
    // content () {
    //   if (this.designPost.hasOwnProperty(this.seq) && this.designPost[this.seq].hasOwnProperty('content')) {
    //     return this.designPost[this.seq].content
    //   }
    //   return ''
    // }
  },
  async created () {
    // if (!this.designPost.hasOwnProperty(this.seq)) {
    //   // this.$store.dispatch('DESIGN_POST', { seq: this.seq })
    // }
  },
  components: {
    ComponentsRenderer
    // ComponentsRenderer: () => import('@/component/common/ComponentsRenderer')
  }
}
</script>
